module.exports = __webpack_public_path__ + "static/Walmart-8ed34e8ad6eb323145dfd9dc173c9566.png";